import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { FormWrapperForTaskWithAction } from 'src/components/FormForTaskWithAction/FormWrapperForTaskWithAction';
import { Header } from 'src/components/Header';
import { SplashScreen } from 'src/components/SplashScreen/SplashScreen';
import { RoutesLayout } from 'src/containers/RoutesLayout/RoutesLayout';
import { useUrlUiSettings } from 'src/hooks/useUrlUiSettings';
import { UrgentTaskView } from 'src/pages/UrgentTaskView/UrgentTaskView';
import { AppStore } from 'src/stores/AppStore/AppStore';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { TaskStore } from 'src/stores/TaskStore/TaskStore';
import { CssVariables } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const AppLayout = observer(() => {
    useUrlUiSettings();

    useEffect(() => {
        if (AuthStore.authenticated) {
            TaskStore.loadAssignedTaskList();
        }
    }, [AuthStore.authenticated]);

    if (
        !AuthStore.authenticated ||
        !AppStore.started ||
        !TaskStore.assignedTaskLoaded
    ) {
        return <SplashScreen />;
    }

    return (
        <Layout>
            <FormWrapperForTaskWithAction />
            {TaskStore.isHasUrgentTask ? (
                <UrgentTaskView />
            ) : (
                <>
                    <Header />
                    <StyledContent>
                        <RoutesLayout />
                    </StyledContent>
                </>
            )}
        </Layout>
    );
});

const StyledContent = styled(Layout.Content)`
    background-color: var(--background);
    margin-top: ${CssVariables.headerHeight};
    height: calc(100vh - ${CssVariables.headerHeight});
`;
